import { Oval } from "react-loader-spinner";

export default function LoaderComponent({ label }) {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center">
      <Oval
        ariaLabel="oval-loading"
        color="#214420"
        secondaryColor="#8f8f8f"
        height="9rem"
        width="9rem"
        strokeWidth={4}
      />
    </div>
  );
}
